<template>
  <div>
    <h4 class="titulo-component">Fórmulário de Inscrição</h4>

    <div class="container-form">
      <el-row :gutter="10">
        <el-form
          :model="dados"
          ref="dados"
          label-position="top"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="18" :md="18">
              <el-form-item :rules="[$requiredBlur]" prop="aluno.nome" key="nome">
                <label class="label">Nome do Aluno</label>
                <el-input v-model="dados.aluno.nome" maxlength="191" v-on:blur="formatDataAluno('nome')"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item :rules="[$requiredBlur, $dataBlur]" prop="aluno.data_nascimento" key="data_nascimento">
                <label>Data de Nascimento</label>
                <el-input v-model="dados.aluno.data_nascimento" @change="calculaIdade()" v-mask="'##/##/####'" v-on:blur="formatDataAluno('data_nascimento', 10)"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="18" :md="18">
              <el-form-item key="responsavel" :rules="[$requiredBlur]" prop="aluno.responsavel">
                <label>Responsável</label>
                <el-input v-model="dados.aluno.responsavel" maxlength="191" v-on:blur="formatDataAluno('responsavel')"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="6" :md="6">
              <el-form-item key="telefone">
                <label>Telefone</label>
                <el-input v-model="dados.aluno.telefone" v-mask="'(##) #########'" v-on:blur="formatDataAluno('telefone', 13)"></el-input>
              </el-form-item>
            </el-col>           

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item key="tipo_documento" :rules="[$requiredChange]" prop="aluno.tipo_documento">
                <label>Tipo de Documento do Aluno</label>
                <el-select ref="tipo_documento" v-model="dados.aluno.tipo_documento">
                  <el-option value="">Selecione</el-option>
                  <el-option key="cpf" label="CPF" value="cpf"></el-option>
                  <el-option key="registro_nasc" label="Certidão de Nascimento" value="registro_nasc"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" v-if="this.dados.aluno.tipo_documento == 'cpf'">
              <el-form-item key="cpf" :rules="[$cpfBlur, $requiredBlur]" prop="aluno.cpf">
                <label>CPF *</label>
                <el-input v-model="dados.aluno.cpf" v-mask="'###.###.###-##'" v-on:blur="formatDataAluno('cpf', 14)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" v-if="this.dados.aluno.tipo_documento == 'registro_nasc'">
              <el-form-item key="registro_nasc" :rules="[$requiredBlur]" prop="aluno.registro_nasc">
                <label>Certidão de Nascimento *</label>
                <el-input v-model="dados.aluno.registro_nasc" v-mask="'######.##.##.####.#.#####.###.#######-##'" v-on:blur="formatDataAluno('registro_nasc', 40)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="container-btns" v-if="step == 1">
            <el-button @click="next()" type="primary">Cadastrar</el-button>
          </div>          
          

          <el-col :xs="24" :sm="24" :md="24" v-if="this.dados.idade_letiva > 5 && step > 1" class="u-mt-10">
            <el-form-item key="referencia_nacional" :rules="[$requiredChange]" prop="referencia_nacional">
              <label>Selecione a modalidade</label>
              <el-select v-model="dados.referencia_nacional" @change="selecionaModalidade()">
                <el-option v-for="(item, i) in modalidades" :key="i" :label="item" :value="i">
                  <span> {{ item }} </span>
                </el-option>
              </el-select> 
            </el-form-item>

          </el-col>

        <div v-if="loadingInst" style="text-align: center; margin-top: 20px;">
          <img src="/public/img/loading-bar.gif" />
        </div>

        <template v-if="!loadingInst">
          
          <el-col :xs="24" :sm="24" :md="24" v-if="step > 2" class="u-mt-10">
            <el-form-item key="instituicao_id" :rules="[$requiredChange]" prop="instituicao_id">
              <label>Selecione a instituição</label>
              <el-select
                v-model="dados.instituicao_id"
                filterable
                @change="selecionaInstituicao()"
              >
                <el-option
                  v-for="(item, i) in instituicoes"
                  :key="i"
                  :label="i"
                  :value="item.instituicao_id"
                >
                  <span style="display: block">{{ i }}</span>
                  <span style="display: block; color: #8492a6; font-size: 11px"
                    >BAIRRO: {{ item.bairro }}</span
                  >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="24" :md="24" v-if="step > 3" class="u-mt-10">
            <el-form-item key="turno" :rules="[$requiredChange]" prop="turno">
              <label>Selecione o turno</label>
              <el-select v-model="dados.turno" @change="selecionaTurno()">
                <el-option
                  v-for="(item, i) in turnos"
                  :key="i"
                  :label="i + (dados.idade_letiva <= 3 && item.vagas == 0 ? ' - (fila de espera)' : (item.vagas == 0 ? ' - (sem vagas)' : ' - ' + item.vagas + ' vagas'))"
                  :value="i"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> 

        </template>

      </el-form> 


      </el-row>
      <div class="container-btns" v-if="dados.turno">
        <el-button @click="concluir()" type="primary" :loading="loadingForm">Concluir</el-button>
      </div>

      <el-alert v-if="erro" style="margin-top: 20px;" :title="erro" :closable="false" type="error" show-icon></el-alert>

    </div>
    <el-dialog :close-on-click-modal="false" :show-close="false" width="20%" title="ATENÇÃO!" :visible.sync="modalSemVagas" class="modal-sem-vaga">
        <div v-if="modalSemVagas" style="margin-top: 20px;">
            
            <div>

              A Instituição selecionada não possui vaga disponível. <br><br>
              {{ dados.aluno.nome }} será inserido na lista de espera e ficará aguardando a desistência de algum outro aluno.

            </div>
            <el-row :gutter="10">
                <el-col :xs="24" class="u-text-center">                  
                  <el-button class="u-mt-20" size="small" type="danger" @click="trocarInstituicao()" style="width: 160px">Trocar Instituição</el-button>
                  <el-button @click="onsubmit()" type="primary" :loading="loadingForm" style="width: 160px">Entrar na Fila de Espera</el-button>
                </el-col>
            </el-row>
        </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      step: 1,
      loadingForm: false,
      loadingInst: false,
      modalSemVagas: false,
      modalSemVagasFundamental: false,
      vagas: {},
      turnos: {},
      modalidades: {},
      instituicoes: {},
      erro: '',
      regular: {
        6: '1º ano',
        7: '2º ano',
        8: '3º ano',
        9: '4º ano',
        10: '5º ano',
        11: '6º ano',
        12: '7º ano',
        13: '8º ano',
        14: '9º ano',
      },
      eja: {
        30: 'Eja - 1º Ano',
        31: 'Eja - 2º e 3º Anos',
        32: 'Eja - 4º e 5º Anos',
        33: 'Eja - 6º e 7º Anos',
        34: 'Eja - 8º e 9º Anos'
      },
      dados: {
        aluno: {
          nome: "",
          data_nascimento: "",
          responsavel: "",
          telefone: "",
          tipo_documento: "",
          cpf: "",
          registro_nasc: ""
        },
        situacao_vaga: true,
        instituicao_id: "",
        turno: "",
        referencia_nacional: "",
        bairro: "",
        idade_letiva: ""
      },
    };
  },
  methods: {
    concluir(){

      if(this.dados.idade_letiva <= 3 && !this.dados.situacao_vaga) {

        this.modalSemVagas = true;
        return;

      } else if(!this.dados.situacao_vaga) {

          Swal.fire({

            title: 'Atenção!',
            text: "A Instituição e turno selecionado não possui vaga disponível.",
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok'

          });

        // this.$alert('A Instituição e turno selecionado não possui vaga disponível.', 'Atenção', {
        //   confirmButtonText: 'Fechar',
        //   callback: action => { }
        // });

      } else {

        this.onsubmit();
      }
      
    },
    onsubmit() {

      this.$refs.dados.validate((valid) =>{ if(valid){

        this.loadingForm = true;

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/salvarPrematriculaNovatos`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

          if(typeof response.data.erro !== 'undefined'){

            this.erro = response.data.erro;
            this.loadingForm = false;
          
          }else{
            
            if(response.data.status == true){
              this.$router.push(`/inscricao/status/${response.data.codigo}`);  
            }

          }

        }).catch((error) => { this.$store.commit('throwException', error); this.loadingForm = false; });

      }else{
        window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
      }});

    },
    trocarInstituicao(){

      this.step = 3;
      this.modalSemVagas = false
      this.dados.instituicao_id = '';
      this.dados.turno = '';

    },
    calculaIdade(){

      const date = new Date();

      const currentYear = date.getFullYear();

      this.step = 1;
      this.dados.referencia_nacional = '';
      this.dados.instituicao_id = '';
      this.dados.turno = '';

      let dtNascimento = this.dados.aluno.data_nascimento.split("/").reverse().join("-");
      let idadeCalculada = this.$moment(`${currentYear}-03-31`).diff(dtNascimento, 'years');   
      
      // console.log(currentYear);
      // console.log(idadeCalculada);     
      

      this.dados.idade_letiva = idadeCalculada 

      // if( this.dados.idade_letiva <= 5){

      //   Swal.fire({

      //     title: 'Atenção!',
      //     text: "Matrículas para alunos de 02, 03, 04 e 05 anos estão suspensas.",
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Ok'

      //   });        

      //   this.dados.aluno.data_nascimento = '';
      // }

      if( this.dados.idade_letiva < 2){

        Swal.fire({

          title: 'Atenção!',
          text: "Idade incompatível. O aluno precisa ter 02 anos completos até 31/03.",
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok'

        });        
      }

      if(this.dados.idade_letiva < 15) {

        this.modalidades = this.regular;

      }else if(this.dados.idade_letiva >= 15 && this.dados.idade_letiva < 18) {

        this.modalidades = Object.assign({}, this.regular, this.eja);

      }else if(this.dados.idade_letiva >= 18) {

        this.modalidades = this.eja;
      }
        
    },
    selecionaModalidade() {

      // if( this.dados.idade_letiva <= 5){

      //   Swal.fire({

      //     title: 'Atenção!',
      //     text: "Matrículas para alunos de 02, 03, 04 e 05 anos estão suspensas.",
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Ok'

      //   });        

      //   return false;
      // }

      this.step = 3;
      this.dados.instituicao_id = '';
      this.dados.turno = '';
      
      this.buscaInstituicoes();
        
    },
    buscaInstituicoes(){

      this.loadingInst = true;

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getInstituicoesWithVagas/${this.dados.referencia_nacional}/${this.dados.idade_letiva}`, this.$store.getters.getHeaderAuth).then(response => {
        
        this.instituicoes = response.data;

        this.loadingInst = false;

      }).catch((error) => { this.$store.commit('throwException', error); });

    },
    selecionaInstituicao() {

      this.step = 4;
      this.dados.turno = '';

      for(let i in this.instituicoes) {
        if(this.instituicoes[i].instituicao_id == this.dados.instituicao_id) {          
          this.turnos = this.instituicoes[i].turnos;
        }
      }
 
    },
    selecionaTurno() {

      this.dados.situacao_vaga = true;

      for(let i in this.instituicoes) {
        if(this.instituicoes[i].instituicao_id == this.dados.instituicao_id) {        
                      
          if(this.instituicoes[i].turnos[this.dados.turno].vagas == 0) {
            this.dados.situacao_vaga = false;
          }

        }
      }
      
    },  
    next() {

      // if( this.dados.idade_letiva <= 5){

      //   Swal.fire({

      //     title: 'Atenção!',
      //     text: "Matrículas para alunos de 02, 03, 04 e 05 anos estão suspensas.",
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Ok'

      //   });        

      //   return false;
      // }

      this.$refs.dados.validate((valid) =>{ if(valid){      

        if (this.dados.idade_letiva < 6) {
          this.dados.referencia_nacional = this.dados.idade_letiva
        } else {
          this.dados.referencia_nacional = this.dados.referencia_nacional
        }

        if(this.dados.idade_letiva <= 5){

          this.step = 3;
          this.buscaInstituicoes();

        }else{
          this.step = 2;
        }

      }else{
        window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
      }});
    
    },
    goBack() {
      this.step--;
    },
    onSubmitBuscaVagas() {},
    formatDataAluno(field, size = null){

        //TRATA OS INPUTS - LETRA MAIÚCULA 
                    
        if(!this.dados.aluno[field])
            return false;

        if(size && this.dados.aluno[field].length < size)
            this.dados.aluno[field] = '';            

        this.dados.aluno[field] = this.dados.aluno[field].toUpperCase();

        this.dados.aluno[field] = this.$removerAcentos(this.dados.aluno[field]);

        this.dados.aluno[field] = this.$removerEspacosDuplos(this.dados.aluno[field]);

        
    }
  },
  components: {},
};
</script>
<style>
.container-btns {
  margin-top: 10px;
  text-align: right;
}
.titulo-form {
  text-align: center;
  margin-top: 30px;
}
.lista-escolas {
  height: 400px;
  overflow: auto;
  padding: 10px;
  margin: 5px;
  border: 1px solid #eeeeee;
}
.lista-escolas ul {
  list-style: none !important;
  padding: 0px;
}
.lista-escolas li {
  margin: 5px 0px;
  cursor: pointer;
  padding: 13px;
  border-radius: 18px;
}
.active {
  background-color: #d1d1d1;
}
.container-form label { 
  margin-bottom: 0px !important;
}

.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

.modal-sem-vaga .el-dialog__header{
  text-align: center !important;
}

.el-dialog__body {
  word-break: normal !important;
}
</style>
